import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';

/**
 * Rollen-/PII-gefilterter Suchkatalog (serverseitig geschnitten). Lange cache-bar — der Katalog
 * ändert sich nur bei Rollen-/Deploy-Wechsel. Owner sehen weder das Gäste-Dataset noch PII-Felder.
 */
export function useAdvancedCatalog() {
  const api = useApi();
  return useQuery({
    queryKey: ['search', 'catalog'],
    queryFn: () => api.search.catalog(),
    staleTime: 5 * 60_000,
  });
}
